// extracted by mini-css-extract-plugin
export var attachmentContainer = "_kj-0";
export var fileList = "_kj-2";
export var removeFileButton = "_kj-1";